import React, { useState } from "react";

// Phones only: clamps content to `height` with a fade + "Read more"; full content on sm+.
export default function ReadMore({ children, height = "max-sm:max-h-[11em]", className = "", wrapClass = "", testid }) {
  const [open, setOpen] = useState(false);
  const clamp = open ? "" : `${height} max-sm:overflow-hidden max-sm:[mask-image:linear-gradient(to_bottom,black_55%,transparent)] max-sm:[-webkit-mask-image:linear-gradient(to_bottom,black_55%,transparent)]`;
  return (
    <div className={wrapClass}>
      <div className={`${className} ${clamp}`} data-testid={testid}>{children}</div>
      <button type="button" onClick={() => setOpen(!open)} className="sm:hidden km-eyebrow text-[10px] text-[#141414] mt-1 py-3.5" aria-expanded={open} data-testid={testid ? `${testid}-toggle` : undefined}>
        <span className="border-b border-[#141414] pb-0.5">{open ? "Read less" : "Read more"}</span>
      </button>
    </div>
  );
}
